import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import ScrollToTop from 'react-scroll-up'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import './all.sass'
import '../../node_modules/animate.css'
import HomeHero from "../components/HomeHero";
import NavbarMobile from "../components/NavbarMobile";

class TemplateWrapper extends React.Component {
    render() {
        let loadVimeo = this.props.location
            && this.props.location.pathname === '/'
            && this.props.location.hash !== "#si";

        return (
            <div>
                {loadVimeo ? <HomeHero/> : null}
                <div id="layout-wrapper">
                    <Helmet
                        bodyAttributes={{
                            oncontextmenu: "return false;"
                        }}>
                        <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.7.2/css/all.css"
                              integrity="sha384-fnmOCqbTlWIlj8LyTjo7mOUStjsKC4pOpQbqyi7RrhN7udi9RwhKkMHpvLbHG9Sr"
                              crossOrigin="anonymous" />
                        <link rel="icon"
                              type="image/png"
                              href="/img/favicon.png"/>
                        <link rel="stylesheet" href="https://use.typekit.net/spa6ulz.css"/>
                    </Helmet>
                    <div id="main">
                        <header className="is-hidden-tablet">
                            <NavbarMobile />
                        </header>
                        <header className="section header section-content-wrapper is-hidden-mobile">
                            <Navbar/>
                        </header>
                        <article>
                            {this.props.children()}
                        </article>
                        <Footer/>
                    </div>
                    <ScrollToTop showUnder={160}>
                        <svg version="1.1"
                             id="Ebene_1"
                             xmlns="http://www.w3.org/2000/svg"
                             x="0px" y="0px"
                             width="53px" height="20px" viewBox="0 0 53 20" enableBackground="new 0 0 53 20"
                             className="back-to-top">
                            <g id="Ebebe_1">
                                <polygon
                                    points="43.886,16.221 42.697,17.687 26.5,4.731 10.303,17.688 9.114,16.221 26.5,2.312"></polygon>
                            </g>
                        </svg>
                    </ScrollToTop>
                </div>
            </div>
        );

    }

    componentDidMount() {
        if (typeof window !== `undefined`) {
            try {
                this.wow = require("wow.js");
                new this.wow({
                    live: false
                }).init();
            } catch (e) {
                console.error(e);
            }
        }
    }

    componentDidUpdate() {
    }
}

TemplateWrapper.propTypes = {
    children: PropTypes.func,
};

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js